import { Col, Row, Form, Input, Divider } from "antd";
import { DepartamentoSelect } from "../ubigeos/DepartamentoSelect";
import { DistritoSelect } from "../ubigeos/DistritoSelect";
import { ProvinciaSelect } from "../ubigeos/ProvinciaSelect";

export const ClienteDireccionPart = () => {
  const form = Form.useFormInstance();
  const departamento = Form.useWatch("departamento", form);
  const provincia = Form.useWatch("provincia", form);

  return (
    <>
      <Divider orientation="left" style={{ margin: "10px 0" }}>
        Dirección
      </Divider>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={6}>
          <Form.Item label="Departamento" name="departamento">
            <DepartamentoSelect
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={6}>
          <Form.Item label="Provincia" name="provincia">
            <ProvinciaSelect
              departamento={departamento}
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={6}>
          <Form.Item label="Distrito" name="ubigeodireccion">
            <DistritoSelect
              provincia={provincia}
              placeholder="[-Seleccione-]"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[0, 24]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={18}>
          <Form.Item name="direccion" label="Dirección">
            <Input placeholder="Ingrese dirección" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
